import { useTranslation } from "react-i18next"
const Subscription = () => {
    const { t } = useTranslation()

    return (
        <div>
            <div className="text-xl font-body font-bold tracking-wide px-4 py-2">
                {t("settings.subscription.header")}
            </div>
            <div className="flex justify-center text-xl font-body tracking-wide px-4 py-2 mt-20">
                {t("settings.subscription.content")}
            </div>
        </div>
    )
}

export default Subscription
